import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9e2cfedc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page-container" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 1,
    class: "no-service-found"
};
const _hoisted_5 = { key: 1 };
import { onBeforeMount, ref, watch } from "vue";
import { useStore } from "@/shared/composables/useStore";
import { AllActionTypes } from "@/store/action-types";
import CatalogServiceAccordeon from "@/components/templates/Catalog/CatalogServiceAccordeon.vue";
import { searchCatalogServiceList, } from "@/repositories/catalog-service.repository";
import Skeleton from "primevue/skeleton";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import OneDeskCard from "@/components/molecules/OneDeskCard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup(__props) {
        const store = useStore();
        const services = ref([]);
        const searchText = ref("");
        const loading = ref(false);
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.WEBSITE);
            await retrieveCatalogServiceList();
        });
        const retrieveCatalogServiceList = async (input = "") => {
            loading.value = true;
            services.value = await searchCatalogServiceList(input);
            loading.value = false;
        };
        watch(searchText, async () => {
            await retrieveCatalogServiceList(searchText.value);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OneDeskCard, {
                    title: "Catalog",
                    "has-search": true,
                    "has-filters": false,
                    "onUpdate:searchText": _cache[0] || (_cache[0] = ($event) => (searchText.value = $event))
                }, {
                    content: _withCtx(() => [
                        (!loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (services.value && services.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
                                            return (_openBlock(), _createBlock(CatalogServiceAccordeon, {
                                                "data-test": "catalog-service",
                                                key: index,
                                                data: service
                                            }, null, 8, ["data"]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, "No service found"))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_unref(Skeleton), {
                                    height: "50px",
                                    "border-radius": "8px"
                                })
                            ]))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
